import { ComponentProps, ComponentType } from 'react';
import { Navigate } from 'react-router-dom';
import { compareAsc } from 'date-fns';
import { TZDate } from '@date-fns/tz';

import useOauth from 'data/oauth/use-oauth';

export function withAuth( Component: ComponentType ) {
	return function WithAuth( props: ComponentProps<typeof Component> ) {
		const { oauth } = useOauth();

		if ( ! oauth.accessToken || ! oauth.expiresAt || compareAsc( new TZDate( new Date() ), oauth.expiresAt ) >= 0 ) {
			return (
				<Navigate to={ `/auth?return=${ encodeURIComponent( window.location.pathname + window.location.search ) }` } replace />
			);
		}

		return <Component { ...props } />;
	};
}
